/**
 * Collect inbound headers whose names contain the x-disney-internal- prefix.
 * Shared by Express SSR config and Angular interceptors for lambda/cache directives.
 */
export function filterDisneyInternalHeaders(
    headers: Record<string, string | string[] | undefined> | null | undefined
): Record<string, string> {
    if (!headers) {
        return {};
    }

    return Object.entries(headers)
        .filter(([key]) => key.includes('x-disney-internal-'))
        .reduce((dest, [key, val]) => {
            if (val === void 0) {
                return dest;
            }

            dest[key] = Array.isArray(val) ? val[0] : val;

            return dest;
        }, {} as Record<string, string>);
}
